import { Box, Button, ButtonProps } from '@mui/material'
import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { QrCodeIcon } from 'src/Libs/flow/icons'

/** Button for starting a QR code scan in the pairing dialogs */
export const QrScanButton: React.FC<{
  onClick: () => void
  disabled?: boolean
  fullWidth?: boolean
  fullHeight?: boolean
  color?: ButtonProps['color']
}> = ({ onClick, disabled, fullWidth, fullHeight, color }) => {
  const { t } = useCustomTranslation()

  return (
    <Button
      variant="outlined"
      size="large"
      color={color ?? 'secondary'}
      startIcon={<QrCodeIcon />}
      onClick={onClick}
      sx={{ display: 'flex', lineHeight: 1, height: fullHeight ? '100%' : undefined, minWidth: 'auto', whiteSpace: 'nowrap' }}
      disabled={disabled}
      fullWidth={fullWidth}
    >
      {/* Allow newline only at spaces, for all translations. */}
      <Box>
        {t('installation.productEditor.pairingEditor.qrCode')
          .split(' ')
          .map((word, i) => (
            <React.Fragment key={`${i}-${word}`}>
              <Box component="span" sx={{ whiteSpace: 'nowrap' }}>
                {word}
              </Box>{' '}
            </React.Fragment>
          ))}
      </Box>
    </Button>
  )
}
